import { formatDateForLocale } from '@/utils/date.utils';

export const DEFAULT_DATE_PLACEHOLDER = 'DD/MM/YYYY';

export const formatDate = (date: Date, locale: string): string => {
  return formatDateForLocale(date, locale) ?? DEFAULT_DATE_PLACEHOLDER;
};
